import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface CreateManualExcelExportRequest {
  productIds: number[];
}

export interface ManualExcelExport {
  id: number;
  status: "PENDING" | "COMPLETED" | "FAILED";
  unoFile?: { id: number };
}

export type CreateManualExcelExportResponse = ManualExcelExport;

export interface CreateManualExcelExportPathParameter {
  buyerId: number;
  orderSheetSetId: number;
}

export const createManualExcelExportKey: YWRKey<CreateManualExcelExportPathParameter> =
  {
    url: ({ buyerId, orderSheetSetId }) =>
      `/buyers/${buyerId}/order-sheet-sets/${orderSheetSetId}/manual-excel-export`,
    method: "post",
  };

export default function useCreateManualExcelExport() {
  const fetcher = useFetcher<
    CreateManualExcelExportRequest,
    CreateManualExcelExportResponse
  >();

  return useYWR(createManualExcelExportKey, fetcher);
}
